export const inicio = {
  saudacao: 'Olá, {{nome}}',
  responder: 'Responder',
  perfis: {
    profissional: 'Profissional',
    administrador: 'Administrador',
  },
} as const;
